"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoMeasurePage = exports.PhotoMeasurePageConfig = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_api_2 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var core_shared_2 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var modal_service_1 = require("../components/modal/modal.service");
var theme_1 = require("../components/theme");
var i18n_1 = require("../i18n");
var mithril_1 = require("../mithril");
var collection_view_1 = require("../modules/collection.view/collection.view");
var collection_view_ctrl_1 = require("../modules/collection.view/collection.view.ctrl");
var drawable_properties_1 = require("../modules/collection.view/drawable.properties");
var vertical_separation_field_view_1 = require("../modules/collection.view/fields/vertical.separation.field.view");
var draw_toolbar_1 = require("../modules/draw.toolbar/draw.toolbar");
var hidden_image_icon_1 = require("../modules/hidden.image.icon/hidden.image.icon");
var photomeasure_collection_list_1 = require("../modules/photomeasure.collection.list/photomeasure.collection.list");
var photomeasure_collection_list_style_1 = require("../modules/photomeasure.collection.list/photomeasure.collection.list.style");
var services_1 = require("../services");
var page_state_1 = require("../state/page.state");
var store_1 = require("../store");
var browser_check_1 = require("../util/browser-check");
var classnames_1 = require("../util/classnames");
var missing_page_1 = require("./missing.page");
var page_1 = require("./page");
var pm_events_1 = require("./photomeasure/pm.events");
var tag_state_1 = require("./tag.state");
var CSS = {
    container: 'c-PhotoMeasure',
    center: 'c-PhotoMeasure__center',
    right: 'c-PhotoMeasure__right',
    empty: 'c-PhotoMeasure__empty',
    hiddenCapture: 'c-PhotoMeasure__hiddenCapture',
    drawWrapper: 'c-PhotoMeasure__drawWrapper'
};
var Style = (_a = {},
    _a[CSS.container] = (_b = {
            height: '100%',
            width: '100%',
            'min-width': '1000px',
            display: 'flex',
            'justify-content': 'space-between'
        },
        _b["& .".concat(core_shared_1.SVGRenderer.CSS.svg)] = {
            outline: "1px solid ".concat(theme_1.DefaultTheme.font.color.divider)
        },
        _b["& .".concat(photomeasure_collection_list_style_1.CSS.container)] = {
            width: '25%',
            'min-width': '400px'
        },
        _b),
    _a[CSS.center] = {
        position: 'relative',
        display: 'flex',
        flex: 1
    },
    _a[CSS.drawWrapper] = {
        position: 'relative',
        flex: 1,
        'text-align': 'center'
    },
    _a[CSS.right] = {
        position: 'relative',
        display: 'flex',
        width: '25%',
        'min-width': '420px'
    },
    _a[CSS.empty] = {
        display: 'flex',
        'align-items': 'center',
        'font-size': '250%',
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[CSS.hiddenCapture + '>:not(i)'] = {
        filter: 'grayscale(100%) brightness(40%)'
    },
    _a);
(0, theme_1.addStyles)(Style);
(0, theme_1.addStyles)(core_shared_1.ZoomRenderer.Style);
(0, theme_1.addStyles)(core_shared_1.SVGRenderer.Style);
exports.PhotoMeasurePageConfig = {
    type: 'internal',
    name: page_1.IkePageName.collectionMeasure,
    path: '/measure',
    auth: {
        required: true
    },
    layout: { nav: false }
};
var isVectorOrAnchor = function (field) {
    return core_shared_1.CollectionModelFieldVector.isVectorField(field) || core_shared_1.CollectionModelFieldAnchor.isAnchorField(field);
};
var recursiveSearchParentForVector = function (subFormInstance) {
    var result = null;
    subFormInstance.forEachField(function (field) {
        if (isVectorOrAnchor(field)) {
            result = field;
        }
    });
    if (!result && subFormInstance.parent.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
        result = recursiveSearchParentForVector(subFormInstance.parent.parent);
    }
    return result;
};
var recursiveSearchParentForOrientation = function (subFormInstance) {
    var result = null;
    subFormInstance.forEachField(function (field) {
        if (field instanceof core_shared_1.CollectionModelFieldNumber &&
            (field.schema.fieldId === 'ipf_equipment:ipf_equipmentOrientation' ||
                field.schema.fieldId === 'equipment:equipmentOrientation')) {
            result = field;
        }
    });
    if (!result && subFormInstance.parent.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
        result = recursiveSearchParentForOrientation(subFormInstance.parent.parent);
    }
    return result;
};
var PhotoMeasurePage = /** @class */ (function (_super) {
    tslib_1.__extends(PhotoMeasurePage, _super);
    function PhotoMeasurePage() {
        var _this = _super.call(this, exports.PhotoMeasurePageConfig) || this;
        _this.invalidUrl = false;
        _this.inspectedVector = null;
        _this.inspectedNumber = null;
        _this.hoveredVector = null;
        _this.hoveredNumber = null;
        _this.browserCheck = new browser_check_1.BrowserCheck();
        return _this;
    }
    PhotoMeasurePage.prototype.init = function () {
        var _this = this;
        page_state_1.CurrentState.reset();
        this.tagState = new tag_state_1.TagState();
        this.events = new pm_events_1.PhotoMeasureInputEvents(this, this.draw);
        this.events.init();
        this.list = new photomeasure_collection_list_1.PhotomeasureCollectionList(this.tagState);
        this.editControl = new collection_view_ctrl_1.CollectionEditCtrl(this.tagState.map);
        this.editControl.isPhotomeasure = true;
        this.detail = new collection_view_1.CollectionEdit(this.editControl);
        this.eventContext = services_1.Services.Input.getContext();
        this.reaction(function () { return page_state_1.CurrentState.inspectedCollectionRevision; }, function () {
            _this.updateInspectedCapture();
            _this.updateURL();
        });
        this.reaction(function () {
            var draw = _this.draw;
            if (draw == null) {
                return null;
            }
            return draw.state.propertiesId;
        }, function (drawableId) { return _this.viewProperties(drawableId); });
        this.reaction(function () { return page_state_1.CurrentState.hoverId; }, function (hoverId) {
            if (hoverId && page_state_1.CurrentState.inspectedCollectionRevision) {
                var collection = store_1.AppStore.Collection.get(page_state_1.CurrentState.inspectedCollectionRevision);
                var field = collection.findField(hoverId);
                if (field instanceof core_shared_1.CollectionModelFieldNumber &&
                    (field.schema.fieldId === 'ipf_equipment:ipf_equipmentOrientation' ||
                        field.schema.fieldId === 'equipment:equipmentOrientation')) {
                    _this.setHoveredNumber(field);
                    return;
                }
                else if (field.parent instanceof
                    core_shared_1.CollectionModelFieldSubFormInstance) {
                    var result = recursiveSearchParentForOrientation(field.parent);
                    if (result) {
                        _this.setHoveredNumber(result);
                        return;
                    }
                }
                if (isVectorOrAnchor(field)) {
                    _this.setHoveredVector(field);
                    return;
                }
                else if (field.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
                    var result = recursiveSearchParentForVector(field.parent);
                    if (result) {
                        _this.setHoveredVector(result);
                        return;
                    }
                }
            }
            _this.setHoveredVector(null);
            _this.setHoveredNumber(null);
        });
        this.reaction(function () { return page_state_1.CurrentState.inspectedFieldId; }, function (inspectedFieldId) {
            if (inspectedFieldId && page_state_1.CurrentState.inspectedCollectionRevision) {
                var collection = store_1.AppStore.Collection.get(page_state_1.CurrentState.inspectedCollectionRevision);
                var field = collection.findField(inspectedFieldId);
                if (field instanceof core_shared_1.CollectionModelFieldNumber &&
                    (field.schema.fieldId === 'ipf_equipment:ipf_equipmentOrientation' ||
                        field.schema.fieldId === 'equipment:equipmentOrientation')) {
                    _this.setInspectedNumber(field);
                    return;
                }
                else if (field.parent instanceof
                    core_shared_1.CollectionModelFieldSubFormInstance) {
                    var result = recursiveSearchParentForOrientation(field.parent);
                    if (result) {
                        _this.setInspectedNumber(result);
                        return;
                    }
                }
                // @todo when anchor location types exist, we need to use the geolib
                // to calculate the bearing, as the anchor may not have a vector provider
                // it might be worth removing the isVectorOrAnchor helper when we integrate this.
                if (isVectorOrAnchor(field)) {
                    _this.setInspectedVector(field);
                    return;
                }
                else if (field.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance) {
                    var result = recursiveSearchParentForVector(field.parent);
                    if (result) {
                        _this.setInspectedVector(result);
                        return;
                    }
                }
            }
            _this.setInspectedNumber(null);
            _this.setInspectedVector(null);
        });
        this.updateInspectedCapture();
        this.parseURL(services_1.Services.Route.params.toJSON());
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)
            || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_CTRL_SHIFT_SELECT)) {
            if (this.browserCheck.os === 'Mac OS') {
                // macos
                this.registerCtrlShiftPressed('keydown', true, { meta: true, shift: true });
                this.registerCtrlShiftPressed('keyup', false, { meta: true });
            }
            // windows
            this.registerCtrlShiftPressed('keydown', true, { ctrl: true, shift: true });
            this.registerCtrlShiftPressed('keyup', false, { ctrl: true });
            // common
            this.registerCtrlShiftPressed('keyup', false, { shift: true });
        }
    };
    Object.defineProperty(PhotoMeasurePage.prototype, "nodes", {
        get: function () {
            if (this.invalidUrl) {
                return (new missing_page_1.MissingPage()).view();
            }
            if (services_1.Services.Department.current == null) {
                return null;
            }
            if (this.tagState == null) {
                this.init();
            }
            return (0, mithril_1.m)('div', { className: CSS.container }, [
                this.list.view(),
                this.viewCenter(),
                (0, mithril_1.m)('div', { className: CSS.right }, [
                    this.detail.view()
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    PhotoMeasurePage.prototype.onRemove = function () {
        _super.prototype.onRemove.call(this);
        this.tagState.destroy();
        this.events.destroy();
        if (this.editControl) {
            this.editControl.destroy();
        }
    };
    PhotoMeasurePage.prototype.viewCenter = function () {
        var _a;
        var _this = this;
        if (this.draw != null) {
            var vector = this.inspectedVector || this.hoveredVector || null;
            var equipmentOrientation = this.inspectedNumber || this.hoveredNumber || null;
            var indicatorColor = vector && vector.parent && services_1.Services.Token.has(core_api_1.IkeToken.PHOTOMEASURE_COLOR_CODING)
                ? core_shared_1.FormModelFieldSubForm.getSpanColor(vector.parent)
                : 'white';
            var hidden = this.draw.state.imageVisibilityHidden;
            // I hate that we have to do this, but there is no other way to figure out where a capture is coming from to be able to determine if it is markable or not
            this.draw.collection.forEachField(function (field) {
                if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field) && field.getCaptureIds().includes(_this.draw.capture.objectId)) {
                    _this.draw.isMarkable = true;
                }
            });
            var isIkeAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
            var renderOptions = {
                draw: this.draw,
                units: services_1.Services.UserSettings.units,
                isEditable: this.draw.isMarkable, // TODO check the permission of the user on the collection
                isInteractive: true,
                isThumbnail: false,
                isInsightMarkerLabelsVisible: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_MARKER_LABELS),
                isInsightMarkersVisible: (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst) && this.draw.state.visibleInsightDetections.includes('marker'),
                insightMarkerTypesVisible: services_1.Services.Token.getByPrefix('feature.insight.marker.').map(function (token) { return token.split('.').pop(); }),
                insightMaskTypesVisible: (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst) && this.draw.state.visibleInsightDetections.includes('mask') ? services_1.Services.Token.getByPrefix('feature.insight.mask.').map(function (token) { return token.split('.').pop(); }) : [],
                isVerticalSeparationEnabled: (0, vertical_separation_field_view_1.canUpdate)(),
                useColorCoding: this.editControl.useColorCoding,
                showOrientation: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_PHOTOMEASURE_COMPASS) || isIkeAnalyst,
                orientationBearing: (equipmentOrientation === null || equipmentOrientation === void 0 ? void 0 : equipmentOrientation.value)
                    ? core_shared_1.IkeAngle.toRadians(equipmentOrientation.value)
                    : ((vector === null || vector === void 0 ? void 0 : vector.value) && typeof vector.value === 'object' && 'bearing' in vector.value
                        ? vector.value.bearing
                        : null),
                indicatorColor: indicatorColor,
                enableRoll: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_PHOTOMEASURE_ROLL) && this.draw.isMarkable
            };
            // Update SVG render options in PhotoMeasureInputEvents so that the Arrange Annotations hotkey has access to it
            this.events.renderOptions = renderOptions;
            // Update the IkeDraw in PhotoMeasureInputEvents because the selected photo may have changed
            this.events.draw = this.draw;
            return (0, mithril_1.m)('div', { className: CSS.center }, [
                (0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(CSS.drawWrapper, (_a = {}, _a[CSS.hiddenCapture] = hidden, _a)) }, [
                    core_shared_1.SVGRenderer.view(renderOptions),
                    hidden && hidden_image_icon_1.HiddenImageIcon.view()
                ]),
                // We put the tool bar last as it needs to render over the top of everything
                draw_toolbar_1.DrawToolbar.view(this.draw, this.detail, renderOptions)
            ]);
        }
        if (page_state_1.CurrentState.inspectedCollectionRevision != null) {
            var collectionSummary = store_1.AppStore.CollectionSummary.get(page_state_1.CurrentState.inspectedCollectionRevision);
            if (collectionSummary != null) {
                return (0, mithril_1.m)('div', { className: CSS.empty }, core_shared_1.CaptureProvider.getCaptureIds(this.editControl.collection).length ? (0, i18n_1.Translate)(i18n_1.T.SELECT_CAPTURE) : (0, i18n_1.Translate)(i18n_1.T.NO_CAPTURES));
            }
        }
        return (0, mithril_1.m)('div', { className: core_shared_1.SVGRenderer.CSS.container });
    };
    PhotoMeasurePage.prototype.parseURL = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var activeRoute, departmentId, tagId, collectionUUID, captureId, tag, collectionSummary, tagSummary;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        activeRoute = services_1.Services.Route.active;
                        if (activeRoute == null || activeRoute.config.name !== this.config.name) {
                            return [2 /*return*/];
                        }
                        departmentId = params.d;
                        tagId = params.t;
                        collectionUUID = params.collection;
                        captureId = params.capture;
                        if (!services_1.Services.Department.hasDepartment(departmentId)) {
                            this.setInvalidURL(true);
                            services_1.Services.Log.Logger.warn({ departmentId: departmentId }, 'Department Id in URL is invalid');
                            return [2 /*return*/];
                        }
                        services_1.Services.Department.setDepartment(departmentId);
                        return [4 /*yield*/, store_1.AppStore.Tag.fetch(tagId)];
                    case 1:
                        tag = _a.sent();
                        if (tag == null) {
                            this.setInvalidURL(true);
                            services_1.Services.Log.Logger.warn({ tagId: tagId }, 'Tag Id in URL is invalid');
                            return [2 /*return*/];
                        }
                        services_1.Services.Search.filterState.addTagFilter(tag);
                        if (!(collectionUUID != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, store_1.AppStore.CollectionSummary.getFetchableByUuid(collectionUUID).refetch()];
                    case 2:
                        collectionSummary = _a.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, store_1.AppStore.TagSummary.getFetchable(tagId).fetch()];
                    case 4:
                        tagSummary = _a.sent();
                        return [4 /*yield*/, store_1.AppStore.CollectionSummary.fetch(tagSummary.revisions[0])];
                    case 5:
                        collectionSummary = _a.sent();
                        _a.label = 6;
                    case 6:
                        if (collectionSummary == null) {
                            this.setInvalidURL(true);
                            services_1.Services.Log.Logger.warn({ collectionUUID: collectionUUID }, 'Collection Id in URL is invalid');
                            return [2 /*return*/];
                        }
                        if (collectionSummary.tags.indexOf(core_api_2.SystemTag.deleted) === -1) {
                            page_state_1.CurrentState.setInspectedCollection(collectionSummary.revision, captureId);
                        }
                        else {
                            page_state_1.CurrentState.setInspectedTagId(tagId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PhotoMeasurePage.prototype, "draw", {
        /**
         * @private
         * @deprecated This property will be set to private. Any outside access should go through new public methods that encapsulate the draw state.
         */
        get: function () {
            var editState = page_state_1.CurrentState.CollectionEdit;
            if (!editState.isEditing || page_state_1.CurrentState.CollectionEdit.collectionRevision !== page_state_1.CurrentState.inspectedCollectionRevision) {
                return null;
            }
            if (page_state_1.CurrentState.inspectedCaptureId == null) {
                return null;
            }
            return editState.getIkeDraw(page_state_1.CurrentState.inspectedCaptureId);
        },
        enumerable: false,
        configurable: true
    });
    PhotoMeasurePage.prototype.viewProperties = function (drawableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var drawState, drawable, inputModal, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (drawableId == null || this.draw == null) {
                            return [2 /*return*/];
                        }
                        if (modal_service_1.ModalService.isOpen) {
                            return [2 /*return*/];
                        }
                        drawState = this.draw.state;
                        drawable = this.draw.drawState.getDrawable(drawableId);
                        inputModal = new drawable_properties_1.DrawablePropertiesComponent(drawable);
                        if (!inputModal.isValid) {
                            return [2 /*return*/, drawState.propertiesHide()];
                        }
                        return [4 /*yield*/, inputModal.open()];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            return [2 /*return*/, drawState.propertiesHide()];
                        }
                        if (core_shared_2.CollectionModelDrawableMarker.isBase(drawable)) {
                            this.setBaseOffset(drawable, inputModal.offsetState.value);
                            // This should not trigger as we don't support insight base & base offsets made by the back end yet
                            if (this.draw.drawState.insightBaseOffset) {
                                this.draw.drawState.insightBaseOffset.approveInsightFlag();
                            }
                        }
                        else {
                            if (inputModal.state.value == null || inputModal.state.value.toString().trim().length === 0) {
                                this.setMarkerLabel(drawable, null);
                            }
                            else {
                                this.setMarkerLabel(drawable, inputModal.state.value);
                            }
                        }
                        // Approve the insight flag from the drawable if the user adds a manual label
                        drawable.approveInsightFlag();
                        drawState.propertiesHide();
                        return [2 /*return*/];
                }
            });
        });
    };
    PhotoMeasurePage.prototype.setBaseOffset = function (drawable, value) {
        drawable.Mutator.offset(value);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, 'tool:base:offset', this.draw.collection.revision);
    };
    PhotoMeasurePage.prototype.setMarkerLabel = function (drawable, value) {
        value = value != null ? value.trim() : '';
        if (value.length > 0) {
            drawable.label.Mutator.text(value);
        }
        else {
            drawable.label.Mutator.text(null);
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, 'tool:label', this.draw.collection.revision);
    };
    PhotoMeasurePage.prototype.updateInspectedCapture = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collection, captureId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (page_state_1.CurrentState.inspectedCollectionRevision == null) {
                            return [2 /*return*/];
                        }
                        this.tagState.map.zoomToCollection(page_state_1.CurrentState.inspectedCollectionRevision);
                        return [4 /*yield*/, store_1.AppStore.Collection.fetch(page_state_1.CurrentState.inspectedCollectionRevision)];
                    case 1:
                        collection = _a.sent();
                        if (collection.revision !== page_state_1.CurrentState.inspectedCollectionRevision) {
                            // Inspected collection may change while downloading collection
                            return [2 /*return*/];
                        }
                        captureId = page_state_1.CurrentState.inspectedCaptureId;
                        if (captureId == null) {
                            captureId = services_1.Services.Collection.getFirstCaptureId(collection);
                        }
                        this.events.trackEvents();
                        page_state_1.CurrentState.setInspectedCollection(page_state_1.CurrentState.inspectedCollectionRevision, captureId);
                        return [2 /*return*/];
                }
            });
        });
    };
    PhotoMeasurePage.prototype.updateURL = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var departmentId, tagId, collectionSummary, collectionUUID, captureId, updateHistory;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        departmentId = services_1.Services.Department.current.objectId;
                        tagId = page_state_1.CurrentState.inspectedTagId || services_1.Services.Route.params.get('t');
                        if (departmentId == null || tagId == null || page_state_1.CurrentState.inspectedCollectionRevision == null) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, store_1.AppStore.CollectionSummary.fetch(page_state_1.CurrentState.inspectedCollectionRevision)];
                    case 1:
                        collectionSummary = _a.sent();
                        collectionUUID = collectionSummary.uuid;
                        captureId = page_state_1.CurrentState.inspectedCaptureId;
                        updateHistory = services_1.Services.Route.params.get('capture') != null;
                        services_1.Services.Route.setAllParams({
                            d: departmentId,
                            t: tagId,
                            collection: collectionUUID,
                            capture: captureId
                        }, updateHistory);
                        return [2 /*return*/];
                }
            });
        });
    };
    PhotoMeasurePage.prototype.setInvalidURL = function (invalid) {
        this.invalidUrl = invalid;
    };
    PhotoMeasurePage.prototype.setInspectedVector = function (field) {
        this.inspectedVector = field;
    };
    PhotoMeasurePage.prototype.setInspectedNumber = function (field) {
        this.inspectedNumber = field;
    };
    PhotoMeasurePage.prototype.setHoveredVector = function (field) {
        this.hoveredVector = field;
    };
    PhotoMeasurePage.prototype.setHoveredNumber = function (field) {
        this.hoveredNumber = field;
    };
    PhotoMeasurePage.prototype.onBeforeUnload = function () {
        this.list.overlay.capture = null;
    };
    PhotoMeasurePage.prototype.registerCtrlShiftPressed = function (eventType, isPressed, modifiers) {
        this.eventContext.on(this.eventContext.Code.AllKeys, function () {
            page_state_1.CurrentState.setIsCtrlShiftPressed(isPressed);
        }, {
            eventType: eventType,
            modifiers: modifiers
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], PhotoMeasurePage.prototype, "invalidUrl", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PhotoMeasurePage.prototype, "inspectedVector", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PhotoMeasurePage.prototype, "inspectedNumber", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PhotoMeasurePage.prototype, "hoveredVector", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PhotoMeasurePage.prototype, "hoveredNumber", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasurePage.prototype, "setBaseOffset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasurePage.prototype, "setMarkerLabel", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasurePage.prototype, "setInvalidURL", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasurePage.prototype, "setInspectedVector", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasurePage.prototype, "setInspectedNumber", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasurePage.prototype, "setHoveredVector", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasurePage.prototype, "setHoveredNumber", null);
    return PhotoMeasurePage;
}(page_1.IkePage));
exports.PhotoMeasurePage = PhotoMeasurePage;
//# sourceMappingURL=photomeasure.page.js.map